import { FormattedString, InfoBlockLayout, InfoBlockStatus, Select, SelectOption } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { licenseTypeUrl } from "../../constants/docConstants";

export interface LicenseTypeSelectProps {
  defaultValue?: string;
  fieldName : string;
  label?: string;
  disabled?: boolean;
  testId?: string;
}

function getLicenseTypes(): SelectOption[] {
  return [
    {
      id: "LICENSE_INCLUDED",
      text: Messages.labels.licenseIncluded(),
    },
    {
      id: "BRING_YOUR_OWN_LICENSE",
      text: Messages.labels.byol(),
    },
  ] as SelectOption[];
}

function licenseStatusInfo(licenseIncluded: JSX.Element, bringYourOwnLicense: JSX.Element): JSX.Element {
  return (
    <>
      {licenseIncluded}
      <br />
      {bringYourOwnLicense}
    </>
  );
}

export const LicenseTypeSelect = (
  { defaultValue, fieldName, label = Messages.labels.licenseType(), disabled, testId }
: LicenseTypeSelectProps,
) : JSX.Element => {
  const licenseTypes = getLicenseTypes();
  const licenseIncluded = FormattedString({ inputText: Messages.hints.licenseIncluded() });
  const BYOL = FormattedString(
    { inputText: Messages.hints.bringYourOwnLicense(licenseTypeUrl) },
  );

  return (
    <Select
      required
      testId={testId}
      fieldName={fieldName}
      label={label}
      options={licenseTypes}
      defaultValue={defaultValue ? [defaultValue] : undefined}
      statusInfo={disabled ? undefined : {
        message: licenseStatusInfo(licenseIncluded, BYOL),
        messageType: InfoBlockStatus.INFO,
        infoLayout: InfoBlockLayout.Compact,
      }}
      disabled={disabled}
      hideSearchBox
    />
  );
};
